const orders_clean = {
  id: "",
  client: "",
  payer: "",
  date: ["", ""],
  supp_date: ["", ""],
  without_shipping: "",
  payment: "",
  payment_reference: "",
  order_row: "",
  delivery: undefined,
  order_shops: undefined,
  total_price_to: "",
  total_price_from: "",
  statusFilter: [],
  categoryFilter: [],
  comment: "",
  comment_state: [],
  serialNumber_check: false,
  serialNumber_switch: false,
  assigned_bills_check: false,
  assigned_bills_switch: false,
  with_errors_check: "",
  with_tax_free: false,
  at_the_store: undefined,
  invoice_email_state: undefined,
  urgents: false,
  supplier: undefined, // remove in future
  supplier_ids: [],
  user_suppliers: [],
  invoice_api_errors: false,
  ship_api_errors: false,
  carrying: false,
  shipment_type: undefined,
  shipments_created_at: ["", ""],
};

const orders_filters = localStorage.getItem("orders_filters")
  ? JSON.parse(localStorage.getItem("orders_filters"))
  : orders_clean;

const initialState = {
  orders: orders_filters,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case "SET_ORDERS_FILTERS":
      setLocalOrder(payload);
      return { ...state, orders: payload };

    case "UPDATE_ORDERS_FILTERS":
      const orderChangeValue = {
        ...state.orders,
        [payload.name]: payload.value,
      };
      setLocalOrder(orderChangeValue);

      return {
        ...state,
        orders: orderChangeValue,
      };
    case "UPDATE_MULTI_ORDERS_FILTERS":
      const orderChangeMultiValue = {
        ...state.orders,
        ...payload,
      };
      setLocalOrder(orderChangeMultiValue);

      return {
        ...state,
        orders: orderChangeMultiValue,
      };
    case "RESET_ORDERS_FILTERS":
      setLocalOrder(orders_clean);
      return {
        ...state,
        orders: {
          ...orders_clean,
          statusFilter: state.orders?.statusFilter || [],
          categoryFilter: state.orders?.categoryFilter || [],
          user_suppliers: state.orders?.user_suppliers || [],
        },
      };

    case "SET_USER_SUPPLIERS":
      return {
        ...state,
        orders: {
          ...state.orders,
          user_suppliers: payload,
        },
      };
    default:
      return state;
  }
}

const setLocalOrder = (obj) =>
  localStorage.setItem("orders_filters", JSON.stringify(obj));
